import resolveApplicationUrl from './resolveApplicationUrl.js';
let wasmBasePath;
export function setWasmBasePath(basePath) {
    wasmBasePath = basePath || undefined;
}
export function getWasmBasePath() {
    return wasmBasePath;
}
export function resolveWasmBasePath(defaultDirectory = '') {
    const directory = wasmBasePath || defaultDirectory;
    return resolveApplicationUrl(!directory || directory.endsWith('/') ? directory : `${directory}/`);
}
